export default "__VITE_ASSET__BoNcEMDQ__";